var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlgCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.77792 8.22709C3.64551 8.18441 3.52069 8.13806 3.40566 8.08766C3.22595 8.00899 3.01557 7.89716 2.83611 7.73464C2.65498 7.57061 2.42871 7.2809 2.42871 6.87524C2.42871 6.46958 2.65498 6.17987 2.83611 6.01585C3.01557 5.85335 3.22595 5.74153 3.40566 5.6628C3.77021 5.50309 4.23312 5.384 4.72407 5.29304C5.72265 5.108 7.05715 5.00024 8.50014 5.00024C9.94312 5.00024 11.2776 5.108 12.2762 5.29304C12.7671 5.384 13.2301 5.50309 13.5946 5.6628C13.7743 5.74153 13.9847 5.85335 14.1641 6.01585C14.3453 6.17987 14.5716 6.46958 14.5716 6.87524C14.5716 7.2809 14.3453 7.57061 14.1641 7.73464C13.9847 7.89716 13.7743 8.00899 13.5946 8.08766C13.4796 8.13806 13.3548 8.18441 13.2223 8.22716V11.8752C13.2223 12.2594 12.9875 12.5631 12.713 12.7796C12.4365 12.9976 12.0663 13.1728 11.6528 13.3107C10.8218 13.5879 9.70706 13.7502 8.50014 13.7502C7.29319 13.7502 6.17847 13.5879 5.34741 13.3107C4.93403 13.1728 4.56377 12.9976 4.28727 12.7796C4.0128 12.5631 3.77792 12.2594 3.77792 11.8752V8.22709ZM12.7718 7.37786L12.774 7.37721C13.2716 7.23209 13.5597 7.0599 13.5597 6.87524C13.5597 6.69059 13.2716 6.51839 12.774 6.37327L12.7718 6.37263C11.8741 6.11119 10.2964 5.93774 8.50014 5.93774C6.70387 5.93774 5.12624 6.11119 4.22843 6.37263L4.22623 6.37327C3.72873 6.51839 3.44062 6.69059 3.44062 6.87524C3.44062 7.0599 3.72873 7.23209 4.22623 7.37721L4.22843 7.37786C5.12624 7.63931 6.70387 7.81271 8.50014 7.81271C10.2964 7.81271 11.8741 7.63931 12.7718 7.37786Z",
    fill: "url(#paint0_linear_1612_306)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5474 1.18422C9.67166 0.953893 10.0265 0.953893 10.1507 1.18422C10.4852 1.80385 10.6007 1.91088 11.2695 2.2207C11.5181 2.33586 11.5181 2.66455 11.2695 2.77971C10.6007 3.08953 10.4852 3.19656 10.1507 3.81619C10.0265 4.04651 9.67166 4.04651 9.5474 3.81619C9.21299 3.19656 9.09747 3.08953 8.42864 2.77971C8.18004 2.66455 8.18004 2.33586 8.42864 2.2207C9.09747 1.91088 9.21299 1.80385 9.5474 1.18422Z",
    fill: "url(#paint1_linear_1612_306)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17453 2.43422C6.29883 2.20389 6.65361 2.20389 6.77791 2.43422C6.89548 2.65207 6.98691 2.73677 7.22204 2.8457C7.47065 2.96086 7.47065 3.28955 7.22204 3.40472C6.98691 3.51364 6.89548 3.59834 6.77791 3.81619C6.65361 4.04651 6.29883 4.04651 6.17453 3.81619C6.05696 3.59834 5.96553 3.51364 5.7304 3.40472C5.48179 3.28955 5.48179 2.96086 5.7304 2.8457C5.96553 2.73677 6.05696 2.65207 6.17453 2.43422Z",
    fill: "url(#paint2_linear_1612_306)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1612_306",
    x1: 2.47208,
    y1: 9.37496,
    x2: 14.5737,
    y2: 9.32595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1612_306",
    x1: 8.25367,
    y1: 2.5001,
    x2: 11.4565,
    y2: 2.49002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1612_306",
    x1: 5.5506,
    y1: 3.12515,
    x2: 7.40884,
    y2: 3.11929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#431DAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE6DFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlgCap);
export default __webpack_public_path__ + "static/media/blg-cap.f8498c8d0a7282067cca2ccc1d5dc672.svg";
export { ForwardRef as ReactComponent };